import { defineAsyncComponent } from 'vue'
export default {
  dialog: defineAsyncComponent(() => import("/vercel/path0/layouts/Dialog.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/vercel/path0/layouts/default.vue").then(m => m.default || m)),
  scaffold: defineAsyncComponent(() => import("/vercel/path0/layouts/scaffold.vue").then(m => m.default || m)),
  settings: defineAsyncComponent(() => import("/vercel/path0/layouts/settings.vue").then(m => m.default || m)),
  "student-scaffold": defineAsyncComponent(() => import("/vercel/path0/layouts/student-scaffold.vue").then(m => m.default || m))
}